module.exports = __webpack_public_path__ + "static/img/Isaac-Heeney.44d0f34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaac-Heeney.jpg
// module id = FKo7
// module chunks = 0